import { io } from "socket.io-client";

let socket

export const initiateSocketConnection = room => {
    socket = io("wss://api.compareairportparkingdeals.co.uk", {
        withCredentials: true,
        transports: ["websocket"],
        path: "/socket.io/",
        auth: {
            token: "Hanger Dashboard Token",
        },
    })

    console.log("Connected to a socket...")
}

export const inComingIncompleteBooking = booking => {
    console.log("booking", booking)
    if (socket) socket.emit("inComingIncompleteBooking", booking)
}

export default socket;
